<template>
    <div v-loading.fullscreen.lock="fullscreenLoading" element-loading-background="rgba(122, 122, 122, 0.5)">
		<div class="ld-panel-title">
			<h2 class="back-btn">用户列表</h2>
		</div>
		<div class="ld-panel-main">
			<el-button type="primary" class="add" @click="dialogGroupVisible = true">添加用户</el-button>
			<div class="search-main clear">
				<el-input v-model="searchInput" class="input" placeholder="请输入搜索内容..." clearable @clear="handleEmpty"></el-input>
				<span @click="searchClick" class="btn"></span>
			</div>
			<el-table :data="tableData" v-loading="loading" style="width: 100%">
				<el-table-column prop="user_name" label="用户名称" width="180" />
				<el-table-column label="实例 ID(名称)">
					<template #default="scope">
						<span class="instance_name">{{scope.row.instance_id}}</span>
						<span v-if="scope.row.instance_name">({{scope.row.instance_name}})</span>
					</template>
				</el-table-column>
				<el-table-column prop="database" label="数据库" />
				<el-table-column prop="host" label="主机名称" />
				<el-table-column label="授权权限">
					<template #default="scope">
						<el-tag v-if="scope.row.permissions == 1">只读</el-tag>
						<el-tag v-if="scope.row.permissions == 2">读写</el-tag>
						<el-tag v-if="scope.row.permissions == 3">DDL</el-tag>
						<el-tag v-if="scope.row.permissions == 4">DML</el-tag>
						<el-tag v-if="scope.row.permissions == 5">ALL</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120">
				  <template #default="scope">
					<el-button link type="primary" size="small" @click="rowOperation(scope.row,'pwd')">重置密码</el-button>
					<el-button link type="danger" size="small" @click="rowOperation(scope.row,'delete')">删除</el-button>
				  </template>
				</el-table-column>
			</el-table>
			<pageList :pagination="pagination" :paginationTotal="paginationTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></pageList>
		</div>
		<!-- 添加用户 -->
		<el-dialog width="700" :show-close="false" :close-on-click-modal="false" v-model="dialogGroupVisible" title="添加用户">
			<el-form :rules="rules" ref="ruleFormRef" :model="groupForm" :label-width="formLabelWidth">
				<el-form-item label="所属实例" prop="instance_id">
					<el-select v-model="groupForm.instance_id">
						<el-option v-for="item in exampleOptions" :key="item.instance_id" :value="item.instance_id" :label="item.instance_name +'('+item.instance_id+')'"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="数据库">
					<el-input v-model="groupForm.database" autocomplete="off" placeholder="不填写默认为*" />
				</el-form-item>
				<el-form-item label="主机名">
					<el-input v-model="groupForm.host" autocomplete="off" placeholder="不填写默认为%" />
				</el-form-item>
				<el-form-item label="授权权限" prop="permissions">
					<el-radio-group v-model="groupForm.permissions">
						<el-radio label="1">只读</el-radio>
						<el-radio label="2">读写</el-radio>
						<el-radio label="3">DDL
							<el-tooltip>
								<el-icon><QuestionFilled color="#ff6600" /></el-icon>
								<template #content>DDL（data definition language）是对数据对象和对象属性进行操作的语言<br />它的操作会改变表结构，表类型等等数据属性，但是不会改变数据内容</template>
							</el-tooltip>
						</el-radio>
						<el-radio label="4">DML
							<el-tooltip>
								<el-icon><QuestionFilled color="#ff6600" /></el-icon>
								<template #content>DML（data manipulation language）是对数据内容进行操作的语言<br />它的最小操作单位是行</template>
							</el-tooltip>
						</el-radio>
						<el-radio label="5">ALL</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="用户名" prop="user_name">
					<el-input v-model="groupForm.user_name" autocomplete="off" />
				</el-form-item>
				<el-form-item label="密码" prop="password">
					<el-input v-model="groupForm.password" type="password" show-password autocomplete="off" placeholder="请输入初始密码" @blur="passwordblur" @change="passwordvalidate" />
					<div v-if="pwdTip" style="position: absolute;top: 25px;color: #888;font-size: 12px;">8-16个字符，至少包含小写字母、大写字母、数字和字符</div>
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="resetForm(ruleFormRef)">取消</el-button>
					<el-button type="primary" :disabled="submitDisabled" @click="submitForm(ruleFormRef)">提交</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 修改密码 -->
		<el-dialog width="700" :show-close="false" :close-on-click-modal="false" v-model="dialogPwdVisible" title="重置密码">
			<el-form :rules="rulesPwd" ref="rulePwdRef" :model="pwdForm" :label-width="formLabelWidth">
				<el-form-item label="新密码" prop="new_password">
					<el-input v-model="pwdForm.new_password" type="password" show-password autocomplete="off" placeholder="请输入新密码" @blur="passwordblur" @change="newpasswordvalidate" />
					<div v-if="pwdEditTip" style="position: absolute;top: 25px;color: #888;font-size: 12px;">8-16个字符，至少包含小写字母、大写字母、数字和字符</div>
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="resetPwd(rulePwdRef)">取消</el-button>
					<el-button type="primary" :disabled="submitPwdDisabled" @click="submitPwd(rulePwdRef)">提交</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted } from 'vue';
	import { fetchExample,userAdd,fetchList,setPwd,userDelete } from '@/api/users';
	import pageList from '../../components/pageList.vue'
	import { ElMessage, ElMessageBox } from 'element-plus';
	import { QuestionFilled } from '@element-plus/icons-vue';
	
	const fullscreenLoading = ref(false);
	const pwdTip = ref(true);
	const pwdEditTip = ref(true);
	const permissions = ref('1');
	const submitDisabled = ref(false);
	const submitPwdDisabled = ref(false);
	const pagination = reactive({page: 1,size: 15});
	const paginationTotal = ref(0);
	const loading = ref(true);
	const searchInput = ref('');
	const dialogGroupVisible = ref(false);
	const dialogPwdVisible = ref(false);
	const formLabelWidth = ref('150');
	const exampleOptions = ref();
	const userId = ref('');
	const tableData = ref();
	const ruleFormRef = ref(null);
	const groupForm = ref({database:'',host:'',permissions:permissions.value,user_name:'',password:'',instance_id:''})
	const rulePwdRef = ref(null);
	const pwdForm = ref({new_password:''})
	const passValidate = (rule, value, callback) => {
		if (/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^a-zA-Z0-9]).{8,16}$/.test(value)) {
		    callback()
		}else{
			callback(new Error('8-16个字符，至少包含小写字母、大写字母、数字和字符'))
		}
	};
	const rules = reactive({
		instance_id: [
			{ required: true, message: '请选择实例', trigger: 'blur' },
		],
		user_name: [
			{ required: true, message: '请填写用户名称', trigger: 'blur' },
		],
		password: [
			{ required: true, message: '8-16个字符，至少包含小写字母、大写字母、数字和字符', trigger: 'blur' },
			{ validator: passValidate, trigger: 'blur' }
		],
		permissions: [
			{ required: true, message: '请选择授权权限', trigger: 'blur' },
		]
	});
	const rulesPwd = reactive({
		new_password: [
			{ required: true, message: '请输入包含英文字母大小写、数字和特殊符号的8-16位组合', trigger: 'blur' },
			{ validator: passValidate, trigger: 'blur' }
		]
	});
	
	
	const fetchListF = () => {
		const param = {
			'page':pagination.page,
			'size':pagination.size,
			'search':searchInput.value
		}
		fetchList(param).then((res) => {
			paginationTotal.value = res.data.count;
			tableData.value = res.data.list;
			loading.value = false;
		})
	};
	const fetchExampleF = () => {
		const param = {'page':1,'size':9999}
		fetchExample(param).then((res) => {
			exampleOptions.value = res.data.list;
		})
	};
	const passwordvalidate = () =>{
		ruleFormRef.value.validateField('password',(valid) => {
			if(valid){
				pwdTip.value = true
			}else{
				pwdTip.value = false
			}
		})
	}
	const newpasswordvalidate = () =>{
		rulePwdRef.value.validateField('new_password',(valid) => {
			if(valid){
				pwdEditTip.value = true
			}else{
				pwdEditTip.value = false
			}
		})
	}
	const passwordblur = () => {
		if(groupForm.value.password == ''){
			pwdTip.value = false
		}
		if(pwdForm.value.new_password == ''){
			pwdTip.value = false
		}
	}
	const rowOperation = (row, now) => {
		if(now == 'pwd'){
			dialogPwdVisible.value = !dialogPwdVisible.value;
			userId.value = row.common_user_id;
		}
		if(now == 'delete'){
			const param = {"common_user_id": row.common_user_id}
			ElMessageBox.confirm(
				'确定要删除该用户吗？',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					showClose:false,
					type: 'warning',
				}
			)
			.then(() => {
				fullscreenLoading.value = true;
				userDelete(param).then((res) => {
					if(res.code === 200){
						ElMessage({
							type: 'success',
							message: res.msg,
						})
						fetchListF()
					}
					fullscreenLoading.value = false;
				})
			})
			.catch(() => {
				
			})
		}
	};
	const submitForm = () => {
		if (!ruleFormRef.value) return;
		ruleFormRef.value.validate((valid) => {
			if (valid) {
				submitDisabled.value = true;
				fullscreenLoading.value = true;
				groupForm.value.permissions = parseInt(groupForm.value.permissions)
				groupForm.value.database = groupForm.value.database == '' ? '*' : groupForm.value.database;
				groupForm.value.host = groupForm.value.host == '' ? '%' : groupForm.value.host;
				const param = groupForm.value;
				userAdd(param).then((res) => {
					if(res.code === 200){
						ElMessage({
							offset:70,
							message: res.msg,
							type: 'success'
						})
						resetForm();
						fetchListF();
					}
					fullscreenLoading.value = false;
					submitDisabled.value = false;
				})
			} else {
				pwdTip.value = false;
				return false;
			}
		});
	};
	const resetForm = () => {
		groupForm.value = {database:'',host:'',permissions:permissions.value,user_name:'',password:'',instance_id:''};
		ruleFormRef.value.resetFields();
		dialogGroupVisible.value = !dialogGroupVisible.value;
	}
	const submitPwd = () => {
		if (!rulePwdRef.value) return;
		rulePwdRef.value.validate((valid) => {
			if (valid) {
				pwdForm.value.common_user_id = userId.value;
				const param = pwdForm.value
				submitPwdDisabled.value = true;
				fullscreenLoading.value = true;
				setPwd(param).then((res) => {
					if(res.code === 200){
						ElMessage({
							offset:70,
							message: res.msg,
							type: 'success'
						})
						resetPwd();
						fetchListF();
					}
					fullscreenLoading.value = false;
					submitPwdDisabled.value = false;
				})
			} else {
				pwdEditTip.value = false
				return false;
			}
		});
	}
	const resetPwd = () => {
		pwdForm.value = {new_password:''};
		pwdEditTip.value = true;
		rulePwdRef.value.resetFields();
		dialogPwdVisible.value = !dialogPwdVisible.value;
	}
	const handleCurrentChange = (e) => {
		pagination.page = e;
		fetchListF();
	};
	const handleSizeChange = (e) => {
		pagination.size = e;
		fetchListF();
	};
	const searchClick = () => {
		fetchListF()
	};
	const handleEmpty = () => {
		fetchListF()
	};
	
	onMounted(() => {
		fetchListF();
	    fetchExampleF();
	})
	
	
</script>

<style lang="scss" scoped>
	.search-main{float: right;}
</style>